<div class="main-logo">
    <span class="main-logo_smart">SMART</span>
    <span class="main-logo_resident">RESIDENT</span>
    <span class="main-logo_subtitle">{{'LOGO.subTitle' | translate}}</span>
</div>
